import { useEffect } from 'react';
import { useNotify } from '../components/notices';
import { SettingsForm } from '../components/SettingsForm';
import { PageHeading } from '../components/ui';
import { useRepo } from '../context';
import { errorText } from '../lib/download';
import { newId } from '../lib/ids';
import { hrefFor, navigate } from '../lib/router';
import { createTournament } from '../lib/session';
import { emptySettingsForm } from '../lib/settings';

export function NewTournamentPage() {
  const repo = useRepo();
  const notify = useNotify();
  useEffect(() => {
    document.title = 'New tournament · Chess TD';
  }, []);
  return (
    <section>
      <nav aria-label="Breadcrumb" className="breadcrumb no-print">
        <a href={hrefFor({ name: 'list' })}>Tournaments</a>
      </nav>
      <PageHeading level={1}>New tournament</PageHeading>
      <SettingsForm
        initial={emptySettingsForm()}
        submitLabel="Create tournament"
        onSubmit={async (settings) => {
          try {
            const id = await createTournament(repo, {
              type: 'TournamentCreated',
              id: newId('t'),
              settings,
            });
            notify(`Created "${settings.name}". Add the players next.`);
            navigate({ name: 'tournament', id, tab: 'players' });
          } catch (e) {
            notify(`Could not create the tournament: ${errorText(e)}`, 'error');
          }
        }}
      />
    </section>
  );
}
